import React, { useState, useEffect } from 'react';
import { Layout, Avatar, Button, Typography, Space, message, Menu } from 'antd';
import {
    UserOutlined,
    LogoutOutlined,
    FileTextOutlined,
    ClockCircleOutlined,
    TeamOutlined,
    CheckCircleOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import DiemDanhComponent from './DiemDanhComponent';
import JobHistoryComponent from './JobHistoryComponent';
import ViecDangLamComponent from './ViecDangLamComponent';
import GiaoViecComponent from './GiaoViecComponent';

const { Header, Content, Sider } = Layout;
const { Title, Text } = Typography;

const Home = () => {
    const [userInfo, setUserInfo] = useState({});
    const [selectedMenu, setSelectedMenu] = useState('giao-viec');
    const navigate = useNavigate();

    useEffect(() => {
        // Lấy thông tin user từ localStorage
        const username = localStorage.getItem('username');
        const job = localStorage.getItem('job');
        const avatar = localStorage.getItem('avatar');
        const role = localStorage.getItem('role');
        const userID = localStorage.getItem('userID');

        if (!username) {
            message.error('Vui lòng đăng nhập!');
            navigate('/login');
            return;
        }

        setUserInfo({
            username,
            job,
            avatar,
            role,
            userID
        });
    }, [navigate]);

    const handleLogout = () => {
        // Xóa tất cả thông tin trong localStorage
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userID');
        localStorage.removeItem('username');
        localStorage.removeItem('job');
        localStorage.removeItem('avatar');
        localStorage.removeItem('role');

        message.success('Đăng xuất thành công!');
        navigate('/login');
    };

    const menuItems = [
        {
            key: 'giao-viec',
            icon: <FileTextOutlined />,
            label: 'Giao việc',
        },
        {
            key: 'viec-dang-lam',
            icon: <ClockCircleOutlined />,
            label: 'Việc đang làm',
        },
        {
            key: 'lich-su-doi',
            icon: <TeamOutlined />,
            label: 'Lịch sử đội',
        },
        {
            key: 'thanh-vien-diem-danh',
            icon: <CheckCircleOutlined />,
            label: 'Thành viên điểm danh',
        },
    ];

    const renderContent = () => {
        switch (selectedMenu) {
            case 'giao-viec':
                return <GiaoViecComponent />;
            case 'viec-dang-lam':
                return <ViecDangLamComponent />;
            case 'lich-su-doi':
                return <JobHistoryComponent />;
            case 'thanh-vien-diem-danh':
                return <DiemDanhComponent />;
            default:
                return (
                    <div>
                        <Title level={2}>Dashboard</Title>
                        <Text>Chọn chức năng từ menu bên trái</Text>
                    </div>
                );
        }
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header style={{
                background: '#fff',
                padding: '0 24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'fixed',
                width: '100%',
                zIndex: 1000
            }}>
                <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                    Giao Việc NLTECH
                </Title>

                <Space size="middle">
                    <Avatar
                        size="large"
                        src={userInfo.avatar}
                        icon={<UserOutlined />}
                    />
                    <Text strong>{userInfo.username}</Text>
                    <Button
                        type="primary"
                        danger
                        icon={<LogoutOutlined />}
                        onClick={handleLogout}
                    >
                        Đăng xuất
                    </Button>
                </Space>
            </Header>

            <Layout style={{ marginTop: '64px' }}>
                <Sider
                    width={250}
                    style={{
                        background: '#fff',
                        boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
                        position: 'fixed',
                        height: 'calc(100vh - 64px)',
                        left: 0,
                        top: '64px',
                        overflowY: 'auto'
                    }}
                >
                    <div style={{ padding: '20px', textAlign: 'center', borderBottom: '1px solid #f0f0f0' }}>
                        <Avatar
                            size={64}
                            src={userInfo.avatar}
                            icon={<UserOutlined />}
                            style={{ marginBottom: '12px' }}
                        />
                        <div>
                            <Text strong style={{ display: 'block' }}>{userInfo.username}</Text>
                            <Text type="secondary" style={{ fontSize: '12px' }}>{userInfo.job}</Text>
                        </div>
                    </div>

                    <Menu
                        mode="inline"
                        selectedKeys={[selectedMenu]}
                        items={menuItems}
                        onClick={(e) => setSelectedMenu(e.key)}
                        style={{
                            border: 'none',
                            marginTop: '16px'
                        }}
                    />
                </Sider>

                <Layout style={{ marginLeft: '250px' }}>
                    <Content style={{
                        padding: '0px',
                        background: '#f0f2f5',
                        minHeight: 'calc(100vh - 44px)'
                    }}>
                        {renderContent()}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default Home;
